<!----------------------------------------------------------Add/Edit New Project --------------------------------------------------------->
<div class="modal-content">
  <!--Header-->
  <div
    class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0"
  >
    <div class="modal-title">
      <h4 class="mb-0">Edit Acquisition</h4>
    </div>
    <button
      type="button"
      class="close-btn"
      style="margin-left: auto"
      (click)="closeModalClick()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!--body-->
  <div class="modal-body pb-4 mt-3">
    <form
      [formGroup]="edit_acquisition_form"
      (ngSubmit)="editAcquisitionClick()"
    >
      <div class="d-flex flex-column gap-3">
        <!--FFL Number-->
        <div class="row align-items-center">
          <label
            for="ffl"
            class="col-sm-4 col-form-label form-label text-end mb-0"
          >
            <span class="text-danger">*</span> FFL:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="ffl"
              [placeholder]="'_-__-___-__-__-_____'"
              [dropSpecialCharacters]="false"
              mask="0-00-000-00-0A-00000"
              (input)="fetchFfl()"
            />
          </div>
        </div>

        <!--Received Name-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="received_from_name"
          >
            <span class="text-danger">*</span> Received From Name:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              #received_from_name
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="received_from_name"
              tooltip="{{
                edit_acquisition_form.get('received_from_name').value
              }}"
              placement="right"
            />
          </div>
        </div>

        <!--Business Name-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="business_name"
          >
            Business Name:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="business_name"
              tooltip="{{ edit_acquisition_form.get('business_name').value }}"
              placement="right"
              [style.background-color]="serial_editing_blackout"
            />
          </div>
        </div>

        <!--Address-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="address"
          >
            Address:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="address"
              tooltip="{{ edit_acquisition_form.get('address').value }}"
              placement="right"
            />
          </div>
        </div>

        <!--Address2-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="address2"
          >
            Address 2:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="address2"
              tooltip="{{ edit_acquisition_form.get('address2').value }}"
              placement="right"
            />
          </div>
        </div>

        <!--Zip Code-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="zip_code"
          >
            Zip Code:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="zip_code"
              (blur)="findStateAndCity()"
            />
          </div>
        </div>

        <!--State-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="state"
          >
            State:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="state"
            />
          </div>
        </div>

        <!--City-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="city"
          >
            City:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <ng-select
              [items]="selected_city_options"
              [multiple]="false"
              [closeOnSelect]="true"
              class="form-control modern-input text-uppercase w-100 p-0 border-0 bg-transparent"
              formControlName="city"
            ></ng-select>
          </div>
        </div>

        <!--Date Acquired-->
        <div class="row align-items-center">
          <label
            class="col-sm-4 col-form-label form-label text-end mb-0"
            for="date_acquired"
          >
            <span class="text-danger">*</span> Date Acquired:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <input
              #date_acquired
              type="text"
              class="form-control modern-input text-uppercase w-100"
              formControlName="date_acquired"
              placeholder="__/__/__ __:__"
              [bsConfig]="bsConfig"
              [(bsValue)]="today"
              [readOnly]="false"
              bsDatepicker
            />
          </div>
        </div>

        <!-- Edit Notes -->
        <div class="row align-items-start mt-3">
          <label
            for="edit_note"
            class="col-sm-4 col-form-label form-label text-end mb-0 pt-2"
          >
            <span class="text-danger">*</span>Edit Note:
          </label>
          <div class="col-sm-8 flex-grow-1">
            <textarea
              class="form-control modern-input w-100"
              formControlName="edit_note"
              id="edit_note"
              name="edit_note"
              style="min-height: 100px; resize: vertical"
              rows="4"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="d-flex justify-content-between mt-3 px-3">
        <button
          type="button"
          class="btn modern-btn secondary-btn px-4"
          (click)="closeModalClick()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn modern-btn primary-btn px-4"
          [disabled]="edit_acquisition_form.invalid"
        >
          Edit Acquisition
        </button>
      </div>
    </form>

    <div class="mt-4 ms-2">
      <span class="text-danger">*</span>
      <span class="text-light" style="font-size: 0.9rem"
        >denotes required fields</span
      >
    </div>
  </div>
</div>

